<div class="search-select-wrapper" [id]="id">
  <div class="floating-label" [class.disabled]="disabled">
    <input
      type="text"
      class="form-control"
      [placeholder]="placeholder"
      [(ngModel)]="displayValue"
      (ngModelChange)="onDisplayValueChange()"
      (focus)="onInputFocus()"
      [disabled]="disabled"
      autocomplete="off"
    />
    <span *ngIf="label">{{ label }}</span>
    <em class="fa fa-chevron-down dropdown-icon" [class.rotated]="showDropdown"></em>
    <em
      *ngIf="selectedItem && !disabled"
      class="fa fa-times clear-icon"
      (click)="clearSelection(); $event.stopPropagation()"
    ></em>
  </div>

  <div class="dropdown-container" [class.open-upward]="openUpward" *ngIf="showDropdown">
    <div class="dropdown-list">
      <div
        *ngFor="let item of filteredItems; let i = index"
        class="dropdown-item"
        [class.selected]="isSelected(item)"
        [class.highlighted]="isHighlighted(i)"
        (click)="selectItem(item)"
      >
        {{ getDisplayValue(item) }}
      </div>

      <div *ngIf="filteredItems.length === 0" class="no-results">{{ "search-select.no-results-found" | translate }}</div>
    </div>
  </div>
</div>
